import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["detail"];

  toggleDetails() {
    this.detailTargets.forEach((detail) => (detail.open = !detail.open));
  }
}
